import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAccountDisplay, IAccountBillTo } from '../../../models/account';
import { RootState } from '../../../store';
import * as accountActions from '../../../store/account/account-actions';
import SelectInput from '../../inputs/select-input';
import { IAccount } from '../../../models/company-account';
import { useBusy } from '../../../hooks/use-busy-hook';

export interface ISelectedAccountState {
    billTo: string;
    shipTo: string;
}

interface ISelectAccountsProps {
    billToAccounts: IAccountBillTo[];
    onChange: (event: any) => void;
    loadBillToAccounts: () => Promise<void>;
}

const SelectAccounts: React.FC<ISelectAccountsProps> = ({
    billToAccounts,
    loadBillToAccounts,
    onChange,
}) => {
    const [shipToAccounts, setShipToAccounts] = useState<IAccount[]>([]);
    const [selectedBillTo, setSelectedBillTo] = useState('');
    const [selectedShipTo, setSelectedShipTo] = useState('');

    useEffect(() => {
        loadBillToAccounts();
    }, []);

    const [setIsBusy] = useBusy();

    const handleShipToChange = (event: any) => {
        const { value } = event.target;
        setIsBusy(true, 150);
        onChange({ target: { name: 'shipTo', value: value } });
        setSelectedShipTo(value);
    };

    const handleBillToChange = (event: any) => {
        const { value } = event.target;
        setIsBusy(true, 150);
        setSelectedBillTo(value);
    };

    useEffect(() => {
        const billTo = billToAccounts.find(
            (a) => a.accountNumber === selectedBillTo
        );
        let shipTo = '';

        if (billTo) {
            setShipToAccounts(billTo.shipToAccounts);
            if (billTo.shipToAccounts.length === 1) {
                shipTo = billTo.shipToAccounts[0].accountNumber;
            } else {
                shipTo = '';
            }
        } else {
            shipTo = '';
            setShipToAccounts([]);
        }

        if (shipTo !== selectedShipTo) {
            onChange({ target: { name: 'shipTo', value: shipTo } });
            setSelectedShipTo(shipTo);
        }

        onChange({ target: { name: 'billTo', value: selectedBillTo } });
    }, [selectedBillTo]);

    return (
        <>
            {billToAccounts.length > 0 && (
                <div className="well form-horizontal">
                    <SelectInput
                        name="billTo"
                        label={'Bill To Account'}
                        options={billToAccounts.map((b) => ({
                            value: b.accountNumber,
                            text: getAccountDisplay(b),
                        }))}
                        value={selectedBillTo}
                        hasDefaultOption={true}
                        defaultOption={'Select'}
                        labelClassName="col-sm-2"
                        onChange={handleBillToChange}
                    />
                    <SelectInput
                        name="shipTo"
                        label={'Ship To Account'}
                        options={shipToAccounts.map((a) => ({
                            value: a.accountNumber,
                            text: getAccountDisplay(a),
                        }))}
                        value={selectedShipTo}
                        hasDefaultOption={
                            selectedBillTo !== '' && shipToAccounts.length !== 1
                        }
                        defaultOption={'Select'}
                        labelClassName="col-sm-2"
                        disabled={shipToAccounts.length < 2}
                        onChange={handleShipToChange}
                    />
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        billToAccounts: state.billToAccounts ? state.billToAccounts.data! : [],
    };
};

const mapDispatchToProps = {
    loadBillToAccounts: accountActions.loadBillToAccounts,
};

const selectAccountsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectAccounts);

export default selectAccountsContainer;
